<template lang="pug">
  .companion-assessment
    WtTile.is-mobile.m-0(vertical).is-justify-content-space-between
      BLoading(:active="assessmentLoading" :is-full-page="true")
      WtTile.m-0.p-0.custom-action(parent)
        WtTile.p-0(parent :col="12" :style="{ 'background-color': '#fff', 'display': 'flex','justify-content': assessmentLoading || saveInProgress ? 'flex-end' : 'space-between','align-items': 'center'}")
          WtSvgIcon(v-if="false" icon="icon_time" width="20px" height="20px" :style="{ 'padding-top': '0.15rem' }")
          p.steps-info(v-if="questionScreen") Step {{ this.currentQuestionIndex + 1}}/{{ this.totalQuestions }} - {{ activeCategory }}
          p.steps-info(v-if="startAssessmentScreen") Create your plan
          WtButton.m-0.p-0(v-if="!assessmentLoading" @click.native="exit" :disabled="assessmentSubmissionScreen" :class="!assessmentSubmissionScreen ? 'active-exit-button':'inactive-exit-button'") Exit
      WtTile.assessment-cover-page(v-if="startAssessmentScreen")
        .flex-cover-page-conatiner
          .flex-cover-page-wrapper
            .flex-figure-wrapper
              .flex-item
                figure.image
                  img.is-rounded(:src="!isEditPlan ? assessmentMetaData.WebAssessmentStartImageUrl : assessmentMetaData.UpdateWebAssessmentStartImageUrl ")
            .flex-info-wrapper
              .flex-title-wrapper
                .flex-item.has-text-centered.py-0(style={color: '#1B1D20'})
                  p.start-title {{ !isEditPlan ? assessmentMetaData.AssessmentStartTitle: assessmentMetaData.UpdateAssessmentStartTitle }}
                .flex-item
                  .cover-page-subtitle {{ !isEditPlan ? assessmentMetaData.AssessmentStartText :  assessmentMetaData.UpdateAssessmentStartText }}
              .flex-item
                WtButton.m-0(color="primary" size="medium" @click.native="startAssessment") {{ !isEditPlan ? 'Create my plan' :'Edit your plan'}}
      WtTile.m-auto(v-if="questionScreen" :col="10")
          .section
            .card
              .card-content.question-container
                  .columns.is-mobile.is-multiline
                    .column.is-full
                      h1.question {{ questions[currentQuestionIndex].Text }}
                      span.selection-info {{ maximumOption > 1 ? `(Select up to ${maximumOption} that have most impacted your wellbeing)`:'' }}
                      WtTile(child).p-0.pt-4.pb-10
                        .column.is-full.pl-0
                          .columns.is-mobile.is-multiline
                              BCheckbox.column.pl-15.pt-2.pb-2.mr-0.options(
                                  v-for="option in questions[currentQuestionIndex].Answers"
                                  :key="option.Id"
                                  :class="['is-' + optionColumnWidth, maximumOption > 1 ? 'is-square' : 'is-circular']"
                                  :native-value="option.Id"
                                  :name="option.Id"
                                  v-model="selectedOptions"
                                  @input="handleOptionSelect(option.Id)"
                                  :disabled="!canSelectOption(option.Id)"
                              ) {{ option.Text }}

      WtTile.action-button-container(v-if="questionScreen")
        .action-buttons
          WtButton.is-outlined(color="primary" size="medium" @click.native="prevQuestion" :disabled="this.currentQuestionIndex == 0") Previous
          WtButton.is-outlined(color="primary" size="medium" @click.native="nextQuestion" v-if="this.currentQuestionIndex !== (this.totalQuestions-1)") Continue
          WtButton.is-outlined(color="primary" size="medium" @click.native="submit" v-if="this.currentQuestionIndex == (this.totalQuestions-1)") Continue
      WtTile(parent v-if="assessmentSubmissionScreen")
        WtTile.m-auto(parent vertical :col="12")
          WtTile.m-auto(:col="4")
            figure.image.mt-6.assessment-image
                img.is-rounded(:src="!isEditPlan ? assessmentMetaData.WebAssessmentEndImageUrl : assessmentMetaData.UpdateWebAssessmentEndImageUrl")
          WtTile.m-auto(:col="6")
            .columns.is-multiline.is-mobile.end-title-container
              .column.is-full.has-text-centered.p-0(style={color: '#1B1D20'})
                p.end-title {{ !isEditPlan ? assessmentMetaData.AssessmentEndTitle : assessmentMetaData.UpdateAssessmentEndTitle }}
              .column.is-full.has-text-centered.pb-0
                .subtitle {{ !isEditPlan ? assessmentMetaData.AssessmentEndText : assessmentMetaData.UpdateAssessmentEndText }}
          WtTile.m-auto(:col="2")
            div.icon-container.m-auto(v-if="saveInProgress")
              WtSvgIcon.m-auto(icon="companion/loader_icon" width="76px" height="76px")
            WtTile.m-auto(:col="12")(v-if="!saveInProgress")
              WtButton(isRouterLink size="medium" :to="{ name: 'MyDashboard' }") View Your Plan
</template>
<script>
import { mapActions } from "vuex";
import WtTile from "@@/WtTile/WtTile";
import WtTitle from "@@/WtTitle/WtTitle";
import WtButton from "@@/WtButton/WtButton";
import WtSvgIcon from "@@/WtSvgIcon/WtSvgIcon";
import WtRouterLink from "@@/WtRouterLink/WtRouterLink";

export default {
  name: "Assessment",

  components: {
    WtTile,
    WtTitle,
    WtButton,
    WtSvgIcon,
    WtRouterLink
  },

  data() {
    return {
      currentQuestionIndex: -1,
      totalQuestions: 0,
      answers: [],
      categories: [],
      selectedAnswers: [],
      questionScreen: false,
      startAssessmentScreen: false,
      assessmentSubmissionScreen: false,
      questions: [],
      assessmentMetaData: {},
      attemptedPercent: 0,
      assessmentLoading: true,
      saveInProgress: false,
      isEditPlan: false
    };
  },
  computed: {
    activeCategory() {
      return this.questions[this.currentQuestionIndex].Title;
    },
    optionColumnWidth() {
      // disabling multiple columns on all size screen
      if (window.innerWidth > 0) {
        return 12;
      } else {
        return Math.floor(
          12 /
            Math.ceil(
              this.questions[this.currentQuestionIndex].Answers.length / 7
            )
        );
      }
    },
    maximumOption() {
      return this.questions[this.currentQuestionIndex].MaximumAnswers;
    },
    selectedOptions: {
      get() {
        if (this.selectedAnswers[this.currentQuestionIndex]) {
          return this.selectedAnswers[this.currentQuestionIndex].Answers.map(
            el => el.Id
          );
        } else {
          return [];
        }
      },
      set() {}
    }
  },
  async mounted() {
    try {
      document.querySelector("html").style.backgroundColor = "#f1f3f8";
      let response = await this.fetchQuestion();
      this.assessmentLoading = false;
      const { Questions, ...metaData } = response.data;
      this.questions = Questions;
      this.assessmentMetaData = metaData;
      this.startAssessmentScreen = true;
      this.isEditPlan = this.hasSubmittedBefore();
    } catch (e) {
      this.snackBar({
        duration: 5000,
        type: "is-danger",
        message: e.message
      });
    }
  },
  beforeDestroy() {
    document.querySelector("html").style.backgroundColor = "#F7F7F7";
  },
  methods: {
    ...mapActions("companion", [
      "fetchQuestion",
      "storeQuestion",
      "setAssessmentState"
    ]),
    ...mapActions(["snackBar"]),

    goBack() {
      window.history.back();
    },

    hasSubmittedBefore() {
      for (let i = 0; i < this.questions.length; i++) {
        const answers = this.questions[i].Answers;
        for (let j = 0; j < answers.length; j++) {
          if (answers[j].Selected) {
            return true;
          }
        }
      }
      return false;
    },

    startAssessment() {
      this.currentQuestionIndex = 0;
      this.totalQuestions = this.questions.length;
      this.categories = this.questions.map(el => el.Title);
      this.populateInitialSelections();
      this.startAssessmentScreen = false;
      this.questionScreen = true;
    },
    populateInitialSelections() {
      try {
        this.questions.forEach(question => {
          const selectedAnswers = question.Answers.filter(
            answer => answer.Selected
          ).map(answer => ({ Id: answer.Id }));
          this.selectedAnswers.push({
            Id: question.Id,
            Answers: selectedAnswers
          });
        });
      } catch (error) {
        this.snackBar({
          message: error.message
        });
      }
    },
    handleSingleChoice(answerId) {
      try {
        let currentSelectedOptions = this.selectedAnswers[
          this.currentQuestionIndex
        ].Answers;
        let existingIndex = currentSelectedOptions.findIndex(
          el => el.Id === answerId
        );
        if (existingIndex === -1) {
          this.selectedAnswers[this.currentQuestionIndex].Answers = [];
          this.selectedAnswers[this.currentQuestionIndex].Answers.push({
            Id: answerId
          });
        } else {
          this.selectedAnswers[this.currentQuestionIndex].Answers.splice(
            existingIndex,
            1
          );
        }
      } catch (e) {
        throw e;
      }
    },
    handleMultipleChoice(answerId) {
      try {
        let currentSelectedOptions = this.selectedAnswers[
          this.currentQuestionIndex
        ].Answers;
        let atIndex = currentSelectedOptions.findIndex(
          el => el.Id === answerId
        );
        if (atIndex !== -1) {
          this.selectedAnswers[this.currentQuestionIndex].Answers.splice(
            atIndex,
            1
          );
        } else {
          this.selectedAnswers[this.currentQuestionIndex].Answers.push({
            Id: answerId
          });
        }
      } catch (e) {
        throw e;
      }
    },
    handleOptionSelect(answerId) {
      try {
        let maximumAnswers = this.questions[this.currentQuestionIndex]
          .MaximumAnswers;
        let minimumRequired = this.questions[this.currentQuestionIndex]
          .RequiredAnswers;
        let questionType = "multipleChoice";
        if (maximumAnswers == 1 && maximumAnswers === minimumRequired) {
          questionType = "singleChoice";
        }
        if (questionType == "singleChoice") {
          this.handleSingleChoice(answerId);
        } else {
          this.handleMultipleChoice(answerId);
        }
      } catch (error) {
        this.snackBar({
          message: error.message
        });
      }
    },
    isMaximumSelected() {
      try {
        let maximumAnswers = this.questions[this.currentQuestionIndex]
          .MaximumAnswers;
        let optionsSelected = this.selectedAnswers[this.currentQuestionIndex]
          .Answers.length;
        if (maximumAnswers === optionsSelected) return true;
        return false;
      } catch (error) {
        this.snackBar({
          message: error.message
        });
        return false;
      }
    },
    isMinimumSelected() {
      try {
        let minimumRequired = this.questions[this.currentQuestionIndex]
          .RequiredAnswers;
        let optionsSelected = this.selectedAnswers[this.currentQuestionIndex]
          .Answers.length;
        if (minimumRequired > optionsSelected) {
          return false;
        }
        return true;
      } catch (error) {
        this.snackBar({
          message: error.message
        });
        return true;
      }
    },
    canSelectOption(optionId) {
      try {
        let maximumAnswers = this.questions[this.currentQuestionIndex]
          .MaximumAnswers;
        let minimumRequired = this.questions[this.currentQuestionIndex]
          .RequiredAnswers;

        if (minimumRequired == 1 && maximumAnswers == minimumRequired) {
          return true;
        }
        let optionsSelected = this.selectedAnswers[this.currentQuestionIndex]
          .Answers.length;
        const isSelected = this.selectedAnswers[
          this.currentQuestionIndex
        ].Answers.map(el => el.Id).includes(optionId);
        if (isSelected) {
          return true;
        }
        if (optionsSelected >= maximumAnswers) {
          return false;
        }
        return true;
      } catch (error) {
        this.snackBar({
          message: error.message
        });
        return false;
      }
    },
    prevQuestion() {
      this.currentQuestionIndex = this.currentQuestionIndex - 1;
    },

    nextQuestion() {
      try {
        let isMinSelected = this.isMinimumSelected();
        if (!isMinSelected) {
          let minimumRequired = this.questions[this.currentQuestionIndex]
            .RequiredAnswers;
          let maximumAnswers = this.questions[this.currentQuestionIndex]
            .MaximumAnswers;
          let message =
            maximumAnswers == 1
              ? "Select an answer before you continue"
              : `Select at least ${minimumRequired} answer before you continue`;
          this.snackBar({
            message: message
          });
          return false;
        }
        this.currentQuestionIndex = this.currentQuestionIndex + 1;
      } catch (error) {
        console.log(error);
      }
    },
    async exit() {
      this.$buefy.dialog.confirm({
        title: "Your plan",
        confirmText: "Exit",
        type: "is-danger",
        hasIcon: true,
        message: " If you exit you will lose the answers you have entered.",
        onConfirm: () => {
          if (!this.isEditPlan) {
            this.$router.push({ name: "MyDashboard" });
          } else {
            this.goBack();
          }
        }
      });
    },
    async submit() {
      try {
        let isMinSelected = this.isMinimumSelected();
        if (!isMinSelected) {
          let minimumRequired = this.questions[this.currentQuestionIndex]
            .RequiredAnswers;
          this.snackBar({
            message: `Minimum ${minimumRequired} option is required`
          });
          return false;
        }
        let filteredAssessment = this.selectedAnswers.filter(
          obj => obj.Answers && obj.Answers.length > 0
        );
        this.assessmentSubmissionScreen = true;
        this.questionScreen = false;
        this.saveInProgress = true;
        setTimeout(() => {
          let image = document.querySelector(".assessment-image img");
          const checkImageLoaded = () => {
            this.storeQuestion({
              Questions: filteredAssessment
            }).then(() => {
              this.setAssessmentState({
                assessmentState: this.isEditPlan ? "updated" : "created"
              });
              this.$router.push({ path: "/plan/daily-content" });
            });
          };

          if (!image.complete) {
            image.addEventListener("load", checkImageLoaded);
            image.addEventListener("error", checkImageLoaded);
          } else {
            checkImageLoaded();
          }
        }, 100);
      } catch (e) {
        this.saveInProgress = false;
        this.snackBar({
          duration: 5000,
          type: "is-danger",
          message: e.message
        });
      }
    }
  }
};
</script>
<style scoped>
.companion-assessment {
  width: 100%;
  height: 100%;
  font-size: 24px !important;
  background-color: #f1f3f8 !important;
  font-weight: 400;
  color: #5a5c60;
}

.companion-assessment + .mobile {
  margin: 23px 0 23px 0;
}

.banner {
  background-color: #2972f0 !important;
  padding: 0 !important;
  height: 113px !important;
}
.banner svg {
  width: 100% !important;
}

.custom-action {
  width: 100% !important;
  height: 48px !important;
  background-color: #ffffff;
}

.box {
  background-color: #f1f3f8;
}

.question-container {
  padding: 0px 0px 116px 0px !important;
  max-width: 800px !important;
}

.steps-info {
  font-family: Manrope;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  color: #5a5c60;
}

.flex-cover-page-wrapper {
  display: inline-flex;
  justify-content: center;
  align-items: center;
  gap: 60px;
}
.flex-figure-wrapper {
  display: flex;
  width: 240px;
  height: 240px;
  justify-content: center;
  align-items: center;
}

.flex-info-wrapper {
  max-width: 508px !important;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--Spacing-xxxLarge, 32px);
}

.flex-title-wrapper {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 16px;
}

.start-title {
  font-family: Manrope;
  font-size: 34px;
  font-weight: 400;
  line-height: 40px;
  text-align: center;
  color: #1b1d20;
}

.cover-page-subtitle {
  color: #5a5c60;
  font-family: Manrope;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0.25px;
}

.title-container {
  margin: 3.1875rem auto 1.875rem auto !important;
}

.end-title-container {
  margin: 2rem auto 1.875rem auto !important;
}

.end-title {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0.18000000715255737px;
  color: #1b1d20;
}

.action-button-container {
  background: #fff !important;
  box-shadow: 0px 0px 10px 0px rgba(27, 29, 32, 0.05);
  display: flex;
  height: 116px;
  align-items: center;
  bottom: 0;
  position: fixed;
  width: -webkit-fill-available;
  z-index: 1;
}

.action-buttons {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90% !important;
}

.question {
  font-family: Manrope;
  font-size: 24px;
  font-weight: 500;
  line-height: 30px;
  letter-spacing: 0.18000000715255737px;
  color: #1b1d20;
  padding-bottom: 2px !important;
}

.companion-assessment::-webkit-scrollbar {
  z-index: 2;
}

.selection-info {
  font-family: Manrope;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.25px;
  color: #5a5c60;
  display: flex;
  gap: 2px;
}

.options {
  font-family: Manrope;
  font-size: 18px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.15000000596046448px;
  color: #5a5c60;
}

.subtitle {
  font-size: 16px !important;
  font-weight: 400 !important;
  line-height: 24px !important;
  letter-spacing: 0.25px !important;
  max-width: 90%;
  margin: auto;
  color: #5a5c60;
}

.list-title {
  width: 100%;
  height: 34px;
}

.card {
  background-color: #f1f3f8;
  padding: 3rem 2rem 3rem 3rem !important;
}

.section {
  background-color: #f1f3f8;
  padding: 0px !important;
}

.tile {
  display: flex;
  justify-content: space-around;
}

.tile .is-parent {
  padding: 0rem 1rem 0rem 1rem !important;
}

.active-exit-button {
  background-color: transparent !important;
  border: none !important;
  color: #2972f0 !important;
  justify-content: flex-end;
}

.inactive-exit-button {
  background-color: transparent !important;
  border: none !important;
  color: #5a5c60 !important;
  justify-content: flex-end;
}

.button {
  margin: 0 10px;
  min-width: 100px;
  border-radius: 9px;
  font-family: Manrope;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
  text-align: center;
}

.image img {
  display: block;
  height: 240px;
  width: 240px;
}

@keyframes rotate360 {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.icon-container {
  display: inline-block;
  width: 76px !important;
  height: 76px !important;
  animation: rotate360 1s linear infinite;
  transform-origin: center;
}

@media screen and (max-width: 1024px) {
  .banner {
    height: 80px !important;
  }
  .flex-cover-page-wrapper {
    flex-direction: column !important;
  }

  .flex-info-wrapper {
    align-items: center;
  }
  .flex-title-wrapper {
    align-items: center;
  }
}

@media screen and (min-width: 769px) {
  .assessment-cover-page {
    min-height: 85vh !important;
  }
  .flex-cover-page-conatiner {
    margin: auto;
    margin-top: calc(((85vh - 240px) / 3));
  }
}

@media screen and (max-width: 768px) {
  .banner {
    height: 60px !important;
  }
  tile .is-parent {
    padding: 0rem !important;
  }
  .assessment-cover-page {
    margin-top: 53px !important;
  }
}

@media screen and (max-width: 576px) {
  .banner {
    height: 40px !important;
  }
  tile .is-parent {
    padding: 0rem !important;
  }
  .card {
    padding: 2rem 2rem 2rem 2rem !important;
  }
  .cover-page-subtitle {
    padding-left: 4px;
    padding-right: 4px;
  }
}
</style>
